import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AskQuestionComponent } from './ask-question/ask-question.component';
import { VoiceAgentComponent } from './voice-agent/voice-agent.component';

const routes: Routes = [
  {path: 'askquestions', component: AskQuestionComponent},
  {path: 'aiagent', component: VoiceAgentComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BotRoutingModule { }
